// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-menu .v-text-field--filled[data-v-2129e182]{background-color:#db3539}.v-field--outlined[data-v-2129e182],.v-text-field--solo[data-v-2129e182]{border-radius:0!important}.attached-button[data-v-2129e182]{border-radius:0;box-shadow:none;font-size:12px;height:56px!important;margin-left:-9px;margin-top:-18px;min-width:150px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
